import { GOOGLE_PROFILE_URL, openGoogleProfile } from "@/lib/google";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 grid sm:grid-cols-2 gap-8 items-center">
        <div className="flex items-center gap-4">
          <img
            src="/logo.png"
            alt="AB Details logo"
            className="h-16 w-16 object-contain ring-1 ring-gold/30 rounded-md p-1"
          />
          <div>
            <div className="font-display font-extrabold text-lg">AB Details</div>
            <div className="text-[11px] uppercase tracking-[0.22em] text-gold mt-1">
              Premium detailing · Flawless finish
            </div>
            <div className="text-[11px] uppercase tracking-[0.22em] text-neutral-500 mt-0.5">
              Christchurch · New Zealand
            </div>
          </div>
        </div>
        <div className="text-xs text-neutral-500 sm:text-right">
          <a
            href={GOOGLE_PROFILE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={openGoogleProfile}
            data-testid="footer-google-review"
            className="inline-flex items-center gap-1.5 text-neutral-400 hover:text-white transition-colors uppercase tracking-[0.18em] text-[11px] cursor-pointer"
          >
            ★ Review us on Google
          </a>
          <div className="mt-2">© {new Date().getFullYear()} AB Details. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}
